/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Pth Indicator List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PthIndicatorListView';

export const mapStateToPropsPthIndicatorList = mapStateToProps;
export const mapDispatchToPropsPthIndicatorList = mapDispatchToProps;

export default connect(
  mapStateToPropsPthIndicatorList,
  mapDispatchToPropsPthIndicatorList
)(View);
